module.exports = __webpack_public_path__ + "media/images/home-background-9b6300af37f975e33b88e0147ce0ced4.jpg";